import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useQuery } from 'react-apollo-hooks'
import { ga, Loader } from '../application'
import { useAuth } from '../authContext'
import { TextErrors } from '../notification'
import { tests } from '../resources'
import { BookingsProvider } from './bookingsContext'
import AddBooking from './components/AddBooking'
import BookingList from './components/BookingList'
import InternalToolbar from './components/InternalToolbar'
import * as Queries from './queries'
import RecommendedDestinations from './recommendedDestinations'
import getText, { getTextErrors } from './strings'

const pushToDatalayer = (bookings, historicBookings, userId) => {
  ga.push({
    'event': 'pageData',
    'user': {
      'customerID': userId,
      'loggedInStatus': 'loggedIn',
      'noOfActiveBookings': bookings.length,
      'noOfTotalBookings': bookings.length + historicBookings.length,
      'bookings': bookings.map((b) => {
        return {
          'bookingReference': b.bookingNumber,
          'products': b.products.map((p) => {
            return {
              'productID': p.productId,
              'productName': p.name,
              'productType': p.productType,
              'tuiProductRating': p.classification && p.classification.name,
              'departureDate': b.startDate,
              'departureMonth': moment(b.startDate).format('YYYYMM'),
              'departureYear': moment(b.startDate).format('YYYY'),
              'daysToDeparture': moment(b.startDate).diff(moment(), 'days') + 1,
            }
          }),
        }
      }),
    },
  })
}
const Overview = (props) => {
  const { profile } = useAuth()
  const { loading, data, refetch } = useQuery(Queries.getBookings())
  const [redirectingToMyHoliday, setRedirectingToMyHoliday] = useState(null)
  const whitelistedUsers = ['ADE4A50A-5022-4B06-AD13-2CE3F4D9CA3C', '64F7C50C-D61C-49C9-98A7-5AE10C1D5DA5', '0DDB8B22-A6B9-4BE1-A3F7-50F4ED0C96EB', 'f48130b14f7a4800992e9a2d81d316e1']
  const impersonate = whitelistedUsers.indexOf(profile.id) > -1

  useEffect(() => {
    if (!loading && data.bookings && data.historicBookings) pushToDatalayer(data.bookings, data.historicBookings, profile.id)
    if (!loading && data && props.onBookingsLoaded) {
      props.onBookingsLoaded(data.bookings && data.bookings.length > 0)
    }
  }, [data, profile])

  const hasActiveBookings = data && data.bookings && data.bookings.length > 0

  const bookingsData = {
    redirectingToMyHoliday,
    onRedirectToMyHolidayStart: (bookingNumber) => setRedirectingToMyHoliday(bookingNumber),
    onRedirectToMyHolidayEnd: () => setRedirectingToMyHoliday(null),
  }

  const handleOnBookingAdded = () => {
    refetch()
  }

  return (
    <BookingsProvider data={bookingsData}>
      <div>
        <TextErrors textErrors={getTextErrors()} />
        {impersonate && <InternalToolbar />}
        <AddBooking onBookingAdded={handleOnBookingAdded} />
        {hasActiveBookings && <h2>{getText('overview', 'title')}</h2>}
        {loading ? (
          <Loader />
        ) : (
          <Fragment>
            {tests.switcher_repeater && <RecommendedDestinations bookings={data.bookings} />}
            <BookingList bookings={data && data.bookings} />
          </Fragment>
        )}
      </div>
    </BookingsProvider>
  )
}

export default Overview
